import {
  FileClock,
  Flame,
  FolderTree,
  Gift,
  Globe,
  Image,
  Languages,
  Pin,
  Shield,
  Smartphone,
  UploadCloud,
  Target,
  Users,
  type LucideIcon,
} from 'lucide-react'
import type { Role } from '@/features/auth/types'

export interface NavItem {
  to: string
  label: string
  icon: LucideIcon
  /** Omitted = visible to every signed-in admin. */
  roles?: Role[]
  tag?: string
}

export interface NavGroup {
  label: string
  roles?: Role[]
  items: NavItem[]
}

/** Mirrors the Phase 1 prototype sidebar, group for group. */
export const NAV: NavGroup[] = [
  {
    label: 'User System',
    items: [{ to: '/users', label: 'Users', icon: Users, tag: 'view' }],
  },
  {
    label: 'Growth',
    items: [
      { to: '/quests', label: 'Quests', icon: Target },
      { to: '/rewards', label: 'Rewards', icon: Gift },
    ],
  },
  {
    label: 'Content',
    items: [
      { to: '/promo-banner', label: 'Promo Banner', icon: Image },
      { to: '/sponsored-coins', label: 'Sponsored Coins', icon: Pin },
      { to: '/trending', label: 'Trending News', icon: Flame },
      { to: '/app-patch-policy', label: 'App Patch Policy', icon: Smartphone },
    ],
  },
  {
    label: 'Localization',
    items: [
      { to: '/i18n/messages', label: 'Messages', icon: Languages },
      { to: '/i18n/languages', label: 'Languages', icon: Globe },
      { to: '/i18n/modules', label: 'Modules', icon: FolderTree },
      { to: '/i18n/publish', label: 'Publish', icon: UploadCloud },
    ],
  },
  {
    label: 'Administration',
    roles: ['super'],
    items: [
      { to: '/admins', label: 'Admins & Roles', icon: Shield, roles: ['super'] },
      { to: '/audit', label: 'Audit Log', icon: FileClock, roles: ['super'] },
    ],
  },
]

export function visibleNav(role: Role): NavGroup[] {
  return NAV.filter((group) => !group.roles || group.roles.includes(role)).map((group) => ({
    ...group,
    items: group.items.filter((item) => !item.roles || item.roles.includes(role)),
  }))
}
